<div class="chat-msg-block">
    <ul>
        <ng-container *ngIf="chatMessages.length">
            <li class="thread mx-0" [class]="msg.type" *ngFor="let msg of chatMessages">
                <div *ngIf="msg?.question">
                    <div class="d-flex align-items-baseline">
                        <div class="pl-0 user-logo">{{userData['name'].charAt(0)}}
                        </div>
                        <h3>{{msg?.question}}</h3>
                    </div>
                    <div class="d-flex1">
                        <div class="chat-msg" *ngIf="msg?.answer && msg?.answer != 'null'">
                            {{ msg?.answer ? msg?.answer 
                                : 'Something went wrong. Please retry'}}
                        </div>
                        <div class="chat-msg" *ngIf="msg['plot'] == 'Could not answer,Please try again later!'">
                            {{ 'Could not answer,Please try again later!' }}
                        </div>
                        <div class="col-md-12" *ngIf="msg['plot'] && msg['plot'] != 'Could not answer,Please try again later!'">
                            <iframe style="width: 100%; min-height: fit-content;  max-height: 500px;"
                                title="Charts" [srcdoc]="msg['plot']"></iframe>
                          </div>
                    </div>
                </div>
            </li>
        </ng-container>
        <li class="thread mx-0" *ngIf="loading">
            <div class="d-flex align-items-baseline">
                <div class="pl-0 user-logo">{{userData['name'].charAt(0)}}</div>
                <h3>{{ latestQues }}</h3>
            </div>
        </li>
        <li class="thread text-center" *ngIf="loading">
            <p style="color: #0073ff;font-size:14px !important;">Please wait for a
                few minutes for the LLM server to initialize.</p>
            <div class="loader-wrapper ">
                <div class="loader-container mt-1">
                    <div class="ball-pulse loader-primary">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>

<div class="message-area">
    <div class="message-input-block">
        <div class="message-input-holder">
            <textarea placeholder="Please enter your query" #msgInput [(ngModel)]="question"></textarea>
            <button class="submit btn-enable" (click)="postQuery()">
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</div>